export default "__VITE_ASSET__Bnt7msLK__"